module.exports = __webpack_public_path__ + "static/img/14000793.6b046312.png";